import { ArrowRight, Eye, EyeOff, KeyRound } from "lucide-react";
import { useState, type FormEvent } from "react";
import { useNavigate, useSearchParams } from "../router";
import { api } from "../api";
import { Button } from "../components/Ui";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setError(""); setLoading(true);
    try {
      await api("/api/auth/login", { method: "POST", body: JSON.stringify({ email, password }) });
      const returnTo = params.get("returnTo");
      if (returnTo) window.location.href = returnTo;
      else navigate("/board");
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Не удалось войти");
    } finally { setLoading(false); }
  };
  return <div className="login-page">
    <div className="login-form-wrap">
      <form className="login-form" onSubmit={submit}>
        <div className="login-form__head">
          <div className="login-form__icon"><KeyRound size={18} /></div>
          <div><h2>Войти в workspace</h2><p>Роль определяет очередь, действия и экраны.</p></div>
        </div>
        <label><span>Email</span><input autoFocus autoComplete="email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></label>
        <label><span>Пароль</span><div className="password-box">
          <input autoComplete="current-password" type={show ? "text" : "password"} required value={password} onChange={(event) => setPassword(event.target.value)} />
          <button type="button" aria-label={show ? "Скрыть пароль" : "Показать пароль"} onClick={() => setShow((value) => !value)}>{show ? <EyeOff size={15} /> : <Eye size={15} />}</button>
        </div></label>
        {error && <div className="form-error">{error}</div>}
        <Button variant="primary" loading={loading} type="submit">Войти <ArrowRight size={16} /></Button>
      </form>
    </div>
  </div>;
}
